/**
 * The page's date range (ADR 0109): a header row with what the range covers and the one control.
 * The range lives in the URL, so a link carries it.
 */
import { DateRangePicker, cn } from '@orgus/ui';
import type { DateRange } from '@orgus/ui';
import type { ReactNode } from 'react';

export function RangeControl({ range, setRange, title, lead, className }: { range: DateRange; setRange(r: DateRange): void; title?: ReactNode; lead?: ReactNode; className?: string }) {
  return (
    <div className={cn('flex min-w-0 flex-wrap items-center justify-between gap-3', className)}>
      <div className="flex min-w-0 items-center gap-3">
        {lead}
        {title != null && <h3 className="text-lead font-semibold text-fg">{title}</h3>}
      </div>
      <DateRangePicker value={range} onChange={setRange} />
    </div>
  );
}
